export interface TravelTimes {
  walkingMinutes: number;
  busMinutes: number;
  carMinutes: number;
}

const WALKING_SPEED_KMH = 5;
const BUS_SPEED_KMH = 20;
const CAR_SPEED_KMH = 40;

/**
 * Calculates estimated travel times for walking, bus, and car
 * based on straight-line distance in kilometers.
 *
 * For negative or zero distance, returns all zeros.
 * Returns non-negative integer minute values (rounded up).
 */
export function calculateTravelTimes(distanceKm: number): TravelTimes {
  if (distanceKm <= 0) {
    return { walkingMinutes: 0, busMinutes: 0, carMinutes: 0 };
  }

  return {
    walkingMinutes: Math.ceil((distanceKm / WALKING_SPEED_KMH) * 60),
    busMinutes: Math.ceil((distanceKm / BUS_SPEED_KMH) * 60),
    carMinutes: Math.ceil((distanceKm / CAR_SPEED_KMH) * 60),
  };
}
